import React from 'react';
import { getSkuPriceData, resolveDiscount } from '../../helper/discount';

export default function DiscountBadge({ product }) {
    if (!product) return null;

    const { percent, extraPercent } = resolveDiscount(getSkuPriceData(product));
    if (!percent) return null;

    return (
        <>
            {/* Main discount badge - original design */}
            <span
                className="discount-badge"
                aria-label={`Discount ${percent}%`}
            >
                -{percent}%
            </span>
            {/* Extra discount badge - positioned below the main badge */}
            {extraPercent > 0 && (
                <span
                    className="discount-badge extra-discount-badge"
                    aria-label={`Extra discount ${extraPercent}%`}
                >
                    EXTRA -{extraPercent}%
                </span>
            )}
        </>
    );
}
